import { get as getCookie, remove as removeCookie, set as setCookie } from 'js-cookie';
import { parse as parseHref } from 'tldjs';

const PORTAL_JWT = 'portal_jwt';
const { domain } = parseHref(window.location.href);

export const getJwt = () => getCookie(PORTAL_JWT) ?? null;

export const setJwt = (jwt: string) =>
	setCookie(PORTAL_JWT, jwt, {
		domain: domain ? `.${domain}` : undefined,
		expires: 365,
		secure: window.location.protocol === 'https:',
	});

export const removeJwt = () =>
	removeCookie(PORTAL_JWT, {
		domain: domain ? `.${domain}` : undefined,
	});
